// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1EPhn"};